module.exports = __webpack_public_path__ + "img/5@2x.89ed1c9.webp";